const config = {
  // API_URL: "http://localhost:5040",
  API_URL: "https://buliservice2000.com",
  API_VERSION: "/api/v1",
  PUBLIC_FOLDER: "/static",
};
export default config;
